import { useTranslation } from 'react-i18next';
import { GetWebSiteUrl, ImageLocation } from 'src/utils/URLUtils';
import styles from './IranianBanner.module.scss';

const IranianBanner = ({ country }: { country: string }) => {
    const { t } = useTranslation();
    const handleLearnMore = () => {
        window.open(GetWebSiteUrl() + '/ir-plans', '_blank');
    }

    if (country !== 'IR') return null;

    return (
        <div className={styles.iranianBanner}>

            <img className={styles.banner}
                src={ImageLocation('Lexi/buy-in-iran.png')}
                alt={t('Iranian users banner')}
                width={300}
                height={300}
            />
            <button
                onClick={handleLearnMore}
                className={styles.prices + ' redButton'}>
                'مشاهده قیمتها'
            </button>

        </div>
    );
};

export default IranianBanner;
